export default {
  // Page title
  'messageAdmin.title': '消息管理',
  'messageAdmin.add': '发送站内信',

  // Actions
  'messageAdmin.action.details': '详情',

  // Columns
  'messageAdmin.column.no': '#NO',
  'messageAdmin.column.id': 'ID',
  'messageAdmin.column.taskId': '任务ID',
  'messageAdmin.column.title': '标题',
  'messageAdmin.column.typeDesc': '类型',
  'messageAdmin.column.msgType': '消息类型',
  'messageAdmin.column.content': '内容',
  'messageAdmin.column.extend': '扩展',
  'messageAdmin.column.pushTime': '发送时间',
  'messageAdmin.column.status': '状态',
  'messageAdmin.column.operator': '操作人',
  'messageAdmin.column.createTime': '创建时间',
  'messageAdmin.column.modifyTime': '修改时间',
  'messageAdmin.column.action': '操作',

  // Search
  'messageAdmin.search.taskId': '任务ID',
  'messageAdmin.search.status': '状态',

  // Form
  'messageAdmin.form.title': '标题',
  'messageAdmin.form.msgType': '消息类型',
  'messageAdmin.form.subtitle': '副标题',
  'messageAdmin.form.content': '内容',
  'messageAdmin.form.type': '发送类型',
  'messageAdmin.form.type.all': '全部用户',
  'messageAdmin.form.type.set': '指定用户',
  'messageAdmin.form.usernoList': '用户ID列表',
  'messageAdmin.form.usernoList.placeholder': '多个ID用英文逗号分隔',
  'messageAdmin.form.pushTime': '发送时间',
};